module.exports = __webpack_public_path__ + "static/media/3.fee610b2.jpg";